@if (file) {
    <div class="file-container d-flex flex-column">
    <div class="view">
        <!-- Tabs -->
        <mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedIndex">
            <mat-tab [disabled]="true">
                <ng-template mat-tab-label>
                    <div class="tab-header-label">
                        <span class="category"><small>File</small></span>
                        <span class="object-name">{{ file.name }}</span>
                    </div>
                </ng-template>
                <!-- No content required -->
            </mat-tab>
            <mat-tab label="Overview">
                <div class="tab-content">
                    <h3>File Overview</h3>
                    <!-- Add overview content here, such as file statistics or metadata -->
                    <p><strong>File ID:</strong> {{ file.fileId }}</p>
                    <p><strong>Name:</strong> {{ file.name }}</p>
                    <p><strong>Description:</strong> {{ file.description }}</p>
                    <p><strong>Enabled:</strong> {{ file.enabled ? 'Yes' : 'No' }}</p>
                    <p><strong>Client ID:</strong> {{ file.clientId }}</p>
                    <p><strong>File Name:</strong> {{ file.fileName }}</p>
                    <p><strong>Brand Domain:</strong> {{ file.brandDomain || 'Global' }}</p>
                    <p><strong>Market:</strong> {{ file.market || 'All markets' }}</p>
                    <p><strong>Updated Date:</strong> {{ file.updatedDate | date:'short' }}</p>
                    <p><strong>Published Date:</strong> {{ file.publishedDate | date:'short' }}</p>
                    @if (file.fileName && file.fileName.length > -1) {
                        <button (click)="downloadFile()" color="primary" mat-raised-button>Download File</button>
                    }
                </div>
            </mat-tab>
            <!-- Settings Tab -->
            <mat-tab label="Settings">
                <div class="tab-content">
                    <app-client-object-settings [clientSettingsForm]="settingsForm"
                                                [object]="file"></app-client-object-settings>
                    <app-file-general-settings (filePublished)="onfilePublished()" [file]="file"
                                               [settingsForm]="settingsForm"></app-file-general-settings>
                </div>
            </mat-tab>
        </mat-tab-group>
        <!-- Save and Delete Buttons -->
        @if ([1, 5, 6, 7].indexOf(tabGroup.selectedIndex!) === -1) {
            <div class="action-buttons">
                <button (click)="save()" [disabled]="isSaving || !settingsForm.touched" color="primary"
                        mat-raised-button>
                    {{ isSaving ? 'Saving...' : 'Save' }}
                </button>
                <button (click)="delete()" [disabled]="isDeleting" color="warn" mat-raised-button>
                    {{ isDeleting ? 'Deleting...' : 'Delete' }}
                </button>
        </div>
        }
    </div>
    </div>
}
